import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
// import { NgSelectModule } from '@ng-select/ng-select';

import { DefaultFilter } from './default-filter';
import { map, distinctUntilChanged, debounceTime } from 'rxjs/operators';

@Component({
    selector: 'completer-filter',
    template: `
  <ng-select [(ngModel)]="query"
        (ngModelChange)="inputTextChanged($event)"
        [items]="column.getFilterConfig().completer.data"
        [minTermLength]="column.getFilterConfig().completer.minSearchLength || 0"
        [typeahead]="column.getFilterConfig().completer.pause || 0"
        [placeholder]="column.getFilterConfig().completer.placeholder || 'Start typing...'"
        (change)="completerContent.next($event)">
  </ng-select>
  `,
    standalone: false
})
export class CompleterFilterComponent extends DefaultFilter implements OnInit {

  public completerContent = new Subject<any>();

  // constructor() {
  //   super();
  // }

  public ngOnInit() {
    // No completerService, data is provided directly to ng-select
    this.changesSubscription = this.completerContent
      .pipe(
        map((ev: any) => (ev && ev.title) || ev || ''),
        distinctUntilChanged(),
        debounceTime(this.delay)
      )
      .subscribe((search: string) => {
        this.query = search;
        this.setFilter();
      });
  }

  public inputTextChanged(event: string) {
    // workaround to trigger the search event when the home/end buttons are clicked
    // when this happens the [(ngModel)]="query" is set to ""
    // but the (selected) method is not called
    // so here it gets called manually
    if (event === '') {
      this.completerContent.next(event);
    }
  }
}